import axios from '@/utils/axios'
import auth from '@/utils/auth';


let socket, 
socketConnecting = false,
heartbeatTimer = null;
// 发送
function send(params) {
  console.log('=send params', params);
  socket.send(JSON.stringify(params));
}
// 获取人员列表
async function getGroupMembers(obj, id, token) {
  let {commit, state} = obj;
  let formData = new FormData();
  formData.append('admin_id', id);
  formData.append('token', token);
  let data = await axios.postFrom('/index.php?ctl=bruce&act=get_my_group_members', formData);
  let list = [];
  if (data.status) {
    data.data.forEach((res) => {
      list.push(...res.children);
    });
  }
  commit('set_personnelList', list);
}
// 创建心跳
function createHeartbeat(userInfo) {
  clearInterval(heartbeatTimer);
  heartbeatTimer = null;
  let params = {
    act: 'ma_get_active_devices',
  };
  send(params);
  heartbeatTimer = setInterval(() => {
    send(params);
  }, 1000 * userInfo.hbInterval);
}
// 获取消息回调
function getMessage(obj, data, userInfo) {
  let {commit, state} = obj;
  return new Promise((resolve, reject) => {
    switch (data.cmd) {
      case 'ma_login':
        if (data.status) {
          commit('SET_ADMININFO', data.admin_info);
          window.sessionStorage.setItem('admin_info', JSON.stringify(data.admin_info));
          resolve(data.admin_info);
          //获取人员列表
          getGroupMembers(obj, data.admin_info.admin_id, state.wsToken);
          createHeartbeat(userInfo);
        } else {
          if (data.msg) {
            this.$message.error(data.msg)
          } else {
            this.$message.error('登陆失败')
          }
        }
        break;
      case 'ma_get_active_devices':
        let newList = JSON.parse(JSON.stringify(state.personnelList));
        // personnelList
        if (newList) {
          newList.forEach((personItem) => {
            if (data.status) {
              let activeDevice = data.data.find(activeItem => personItem.device_id == activeItem.user_info.device_id);
              if (activeDevice) personItem.deviceData = activeDevice;
            } else {
              personItem.deviceData = null;
            }
          });
          commit('set_personnelList', newList);
        }
        break;
      
      default:
        break;
    }
  });
}
// 初始化
function initSocket(obj, userInfo) {
  let {commit, state} = obj;
  return new Promise((resolve, reject) => {
    if (typeof WebSocket === 'undefined') {
      reject();
      alert('您的浏览器不支持socket');
    } else {
      // 实例化socket
      socketConnecting = true;
      socket = new WebSocket(process.env.WEBSTOCKET_URL);
      // 监听socket连接
      socket.onopen = () => {
        send({
          act: 'ma_login',
          user_name: userInfo.userName,
          access_token: state.wsToken
        });
      }
      socket.onclose = () => {
        console.log('socket已经关闭');
      };
      // 监听socket错误信息
      socket.onerror = () => {
        socketConnecting = false;
        console.log('连接错误');
        // TODO 重连
      };
      // 监听socket消息
      socket.onmessage = (msg) => {
        let msgData = JSON.parse(msg.data)
        commit('SET_WSSMSG', msgData);
        getMessage(obj, msgData, userInfo).then(loginRes => {
          resolve(loginRes);
        })
      };
    }
  });
}


async function fn(obj, userInfo) {
  let {commit, state} = obj;
  // 获取pkey
  let pkeyFormData = new FormData();
  pkeyFormData.append('user_name', userInfo.userName);
  // pkeyFormData.append('pwd', 'CS123456dl@');
  pkeyFormData.append('pwd', userInfo.pwd);
  let pkeyData = await axios.postFrom('/index.php?ctl=tool&act=get_pkey', pkeyFormData);
  // let pkey = pkeyData.data
  commit('SET_PKEY', pkeyData.data);

  // 获取token（时效十个小时）
  let tokenFormData = new FormData();
  tokenFormData.append('user_name', userInfo.userName);
  tokenFormData.append('pkey', pkeyData.data);
  let tokenRes = await axios.postFrom('/index.php?ctl=tool&act=get_token', tokenFormData);
  window.sessionStorage.setItem('token', tokenRes.token);
  // token存到store
  // this.token = tokenRes.token;
  commit('SET_WSTOKEN', tokenRes.token);
  return new Promise((resolve, reject) => {
    initSocket(obj, userInfo).then(initRes => {
      resolve(initRes);
    }).catch(err => {
      reject(err);
    });
  });
}

const user = {
  state: {
    username: auth.getUserInfo() ? auth.getUserInfo().userName : '',
    token: auth.getToken(),
    isAllRole: window.sessionStorage.getItem('isAllRole'),
    id: auth.getId(),
    menuIds: auth.getMenuIds(),
    sideBarMenu: auth.getSideBarMenu(),
    topMenu: auth.getTopMenu(),
    msgUnreadNum: 0,

    activePerson: null,
    activeType: '',
    wssMsg: null,
    wsToken: '',
    adminInfo: null,
    personnelList: null,
  },

  mutations: {
    SET_USERINFO: (state, userinfo) => {
      state.username = userinfo.userName;
      state.roleId = userinfo.roleId;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_isAllRole: (state, isAll) => {
      state.isAllRole = isAll;
    },
    SET_ID: (state, id) => {
      state.id = id;
    },
    // 存入wssMsg
    SET_WSSMSG: (state, value) => {
      state.wssMsg = value
    },
    // 存入activePerson
    SET_ACTIVEPERSON: (state, value) => {
      state.activePerson = value
    },
    
    SET_PKEY: (state, val) => {
      state.pkey = val;
    },
    SET_WSTOKEN: (state, val) => {
      state.wsToken = val;
    },
    SET_ADMININFO: (state, val) => {
      state.adminInfo = val;
    },
    set_personnelList: (state, val) => {
      state.personnelList = val;
    },
  },

  actions: {
    // 登录
    Login({commit, state}, userInfo) {
      return fn({commit, state}, userInfo);
    },
    // 登录
    send({commit, state}, params) {
      send(params);
    },
    setToken({commit, state}, token) {
      commit('SET_TOKEN', token)
    },
    setActivePerson({commit, state}, data) {
      let {person, type} = data;
      state.activePerson = person;
      state.activeType = type;
    },
    delActivePerson({commit, state}, data) {
      state.activePerson = null;
      state.activeType = '';
    },
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js